import Table from './Table';
export default Table;


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/table/index.js
// module id = 1547
// module chunks = 0